module.exports = __webpack_public_path__ + "media/images/empty-list-deals-338ecef272de3287009e62a6b333a610.png";